import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import RichTextPHP from './RichTextPHP';

loadDOMComponent({
	selector: 'react-rich-text-field',
	callback: ({ container }: any) => {
		const name = container.getAttribute('name');
		const placeholder = container.getAttribute('placeholder');
		const value = container.getAttribute('value');
		const netteRules = container.getAttribute('data-nette-rules');
		let required = container.getAttribute('required');
		required = required !== false && required !== null;

		ReactDOM.render(
			<AppContextProvider>
				<RichTextPHP
					name={name}
					value={value}
					data-nette-rules={netteRules}
					placeholder={placeholder}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
